import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

import { Confirmable } from '@app/modules/ui/models/confirmable'

import { ButtonComponent } from '../../../modules/ui/components/button/button.component'

@Component({
  selector: 'sb-modal-why-verify',
  templateUrl: './why-verify.component.html',
  styleUrl: '../../../overlays/modal/modal-content.scss',
  imports: [ButtonComponent, RouterLink],
})
export class ModalWhyVerifyComponent extends Confirmable {}
